import {MainRequest, Status} from 'Services/common';
import {traverseTree} from '../../../Utils/common';
import {isEmpty} from '../../../Stores/commonStore';

export interface ServiceData {
    childNumber: string;
    code: string;
    description: string;
    updateUser: string;
    updateTime: string;
    sort: string;
    parentId: string;
    children?: ServiceData[];
    createTime: string;
    levelType: string;
    menuCode: string;
    name: string;
    createUser: string;
    id: string;
    serviceDetailId: string;
    status: Status;
}
export interface GetServiceProps {
    name?: string;
    status?: Status;
}
export function getServicePage(data?: GetServiceProps) {
    return MainRequest.post<SuccessData<ServiceData[]>>(
        '/serviceMenu/listRoot',
        data,
    )
        .then(res => res.data.data)
        .then(res => {
            return {
                data: res,
                total: res?.length,
            };
        });
}

//详情
export function getServiceDetail(id?: string) {
    if (!id) {
        return Promise.resolve(undefined);
    }
    return MainRequest.post<SuccessData<ServiceData>>('/serviceMenu/detail', {
        id,
    }).then(res => res.data.data);
}

//获取菜单
export function getServiceMenu(id?: string) {
    if (!id) {
        return Promise.resolve(undefined);
    }
    return MainRequest.post<SuccessData<ServiceData>>('/serviceMenu/treeNode', {
        id,
    })
        .then(res => res.data.data)
        .then(res => {
            traverseTree(res, (node: ServiceData) => {
                if (isEmpty(node?.children)) {
                    node.children = undefined;
                }
            });
            return res?.children;
        });
}

export enum LevelType {
    Directory = 'DIMTYPE100001',
    Menu = 'DIMTYPE100002',
    H5Menu = 'DIMTYPE100004',
}
export async function getServiceDirectoryOptions(id?: string) {
    const options = await getServiceMenu(id);
    return options?.filter(option => option.levelType === LevelType.Directory);
}

//保存
export interface SaveServiceProps {
    id?: string;
    code: string;
    description: string;
    levelType: string; //01 服务 - 02菜单 http://172.16.30.51:3000/project/69/interface/api/9280
    name: string;
    status: Status;
    parentId: string;
}
export function saveServiceDetail(data: SaveServiceProps) {
    return MainRequest.post('/serviceMenu/save', data);
}
export enum ServiceType {
    Service,
    Menu,
}
export enum ServiceBy {
    Customer,
    Base,
}

//启用停用
export function changeServiceStatus(id: string, status: Status) {
    return MainRequest.post('/serviceMenu/changeStatus', {
        id,
        status,
    });
}

//删除
export function deleteService(id: string) {
    return MainRequest.post('/serviceMenu/delete', {
        id,
    });
}
